import { FormControl } from '@startuptools/ui/joy/FormControl';
import { FormLabel } from '@startuptools/ui/joy/FormLabel';
import { FormHelperText } from '@startuptools/ui/joy/FormHelperText';
import { Box } from '@startuptools/ui/joy/Box';
import { Switch } from '@startuptools/ui/joy/Switch';
import { Trans } from '@lingui/react';
import React from 'react';

interface UpdateFieldProps {
  value: boolean | null | undefined;
  onChange: (value: boolean) => void;
  label: React.ReactNode;
}

export const UpdateField = ({ value, onChange, label }: UpdateFieldProps) => (
  <FormControl sx={{ alignItems: 'flex-start' }}>
    <FormLabel>
      <Trans id="Update {label}" values={{ label }} />
    </FormLabel>

    <FormHelperText sx={{ mt: 0 }}>
      <Trans id="If this is on, a decision regarding the change will be added to the connected meeting." />
    </FormHelperText>
    <Box sx={{ mt: 2 }}>
      <Switch
        checked={value ?? false}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
        color={value ? 'primary' : 'neutral'}
        variant={value ? 'solid' : 'outlined'}
        endDecorator={value ? <Trans id="On" /> : <Trans id="Off" />}
        slotProps={{
          endDecorator: {
            sx: {
              minWidth: 24,
            },
          },
        }}
      />
    </Box>
  </FormControl>
);
